<template>
  <Teleport to="body">
    <div class="listing-search-sheet">
      <div class="listing-search-sheet__scrim" @click="emit('close')" />
      <div class="listing-search-sheet__sheet" role="dialog" aria-modal="true" :aria-label="t('listing-search.sheet.aria-label')">
        <div class="listing-search-sheet__head">
          <span>{{ t('listing-search.location.label') }}</span>
          <button
            ref="closeButton"
            type="button"
            class="listing-search-sheet__close"
            :aria-label="t('listing-search.sheet.close')"
            @click="emit('close')"
          >
            <SvgIcon name="x" :size="17" />
          </button>
        </div>

        <div class="listing-search-sheet__scroll">
          <div class="listing-search-sheet__section is-open">
            <div class="listing-search-sheet__section-body listing-search-sheet__section-body--standalone">
              <input
                class="listing-search-sheet__input"
                maxlength="75"
                :placeholder="t('listing-search.location.placeholder')"
                :value="criteria.loc"
                @input="onLocationInput($event.target.value)"
                role="combobox"
                aria-autocomplete="list"
                :aria-expanded="true"
                :aria-controls="locationPopover && locationPopover.listboxId"
                :aria-activedescendant="locationPopover && locationPopover.activeId"
                @keydown.down.prevent="locationPopover && locationPopover.moveHighlight(1)"
                @keydown.up.prevent="locationPopover && locationPopover.moveHighlight(-1)"
                @keydown.enter.prevent="locationPopover && locationPopover.pickHighlighted()"
              />
              <PopoverLocation
                ref="locationPopover"
                :api="api"
                :bootstrap="bootstrap"
                :criteria-store="criteriaStore"
                :default-radius="defaultRadius"
                projects-first
                @pick-place="emit('pick-place', $event)"
                @pick-project="emit('pick-project', $event)"
              />
            </div>
          </div>
        </div>

        <div class="listing-search-sheet__footer">
          <button type="button" class="listing-search-sheet__reset" @click="emit('reset')">
            <SvgIcon name="x" :size="13" />{{ t('listing-search.sheet.clear-all') }}
          </button>
          <button type="button" class="listing-search-sheet__submit" @click="emit('search')">
            <SvgIcon name="search" :size="17" />{{ t('listing-search.submit') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';
import SvgIcon from './SvgIcon.vue';
import PopoverLocation from './PopoverLocation.vue';
import { t } from '../lib/i18n';

const props = defineProps({
  api: { type: Object, required: true },
  bootstrap: { type: Object, required: true },
  criteriaStore: { type: Object, required: true },
  defaultRadius: { type: Number, required: true }
});

const emit = defineEmits(['close', 'search', 'reset', 'pick-place', 'pick-project']);

const { criteria, update } = props.criteriaStore;

const closeButton = ref(null);
const locationPopover = ref(null);

const onLocationInput = (value) => {
  update({ loc: value, long: null, lat: null });
  emit('pick-place', null);
};

const onKeydown = (event) => {
  if (event.key === 'Escape') emit('close');
};

let previousOverflow = '';

onMounted(() => {
  document.addEventListener('keydown', onKeydown);
  previousOverflow = document.body.style.overflow;
  document.body.style.overflow = 'hidden';
  if (closeButton.value) closeButton.value.focus();
});

onBeforeUnmount(() => {
  document.removeEventListener('keydown', onKeydown);
  document.body.style.overflow = previousOverflow;
});
</script>
